import { useIntl } from "react-intl";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { experiments, useExperiment } from "@/utils/experiment";

type JiraPlainBannersProps = {
    isGwp5090Test?: boolean;
};

const JiraPlainBanners = ({ isGwp5090Test }: JiraPlainBannersProps) => {
    const intl = useIntl();
    const aiBannerMessages: BannerProps = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    let template = <BannerAlert {...aiBannerMessages} />;

    const gwp5090BannerExperiment = useExperiment(
        experiments.gwp5090ExperimentBannerJira
    );
    const gwp5090IsButterBar =
        isGwp5090Test ||
        (gwp5090BannerExperiment &&
            gwp5090BannerExperiment.type === "enrolled" &&
            gwp5090BannerExperiment.value === "butterbar");

    if (gwp5090IsButterBar) {
        template = <></>;
    }
    return template;
};

JiraPlainBanners.displayName = "JiraPlainBanners";

export default JiraPlainBanners;
